import { csrfRequest } from './helpers/request'
import { GENERIC_MFA_ERROR_CODE } from '../../constants/error.codes'

export default data =>
  csrfRequest({
    url: '/users/mfa/totp/register',
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(response => {
    if (response.status === 204) {
      return Promise.resolve(response)
    } else if (response.status === 400) {
      return response.json().then(json => {
        return Promise.reject(new Error(json.code))
      })
    } else {
      return Promise.reject(new Error(GENERIC_MFA_ERROR_CODE))
    }
  })
